import * as React from 'react';
import CageBox from './CageBox';
import { Cage } from './Models';

export default class CageBoxList extends React.Component<{
	cages: Array<Cage>,
	oxygenMinimum: number
}>{
	render() {
		return this.props.cages.map(cage => <CageBox oxygenMinimum={this.props.oxygenMinimum} key={cage.id} cage={cage} />)
	}
}



// WEBPACK FOOTER //
// ./src/CageBoxList.tsx